import { createSlice, type PayloadAction } from '@reduxjs/toolkit';

interface DialogState {
	state: boolean;
	id?: string;
}

const initialState: DialogState = { state: false };

const moduleSearchDialogSlice = createSlice({
	name: 'moduleSearchDialog',
	initialState,
	reducers: {
		openModuleSearchDialog: (state, action: PayloadAction<string>) => {
			state.state = true;
			state.id = action.payload;
			return state;
		},
		closeModuleSearchDialog: state => {
			state.state = false;
			state.id = undefined;
			return state;
		}
	}
});

export const { openModuleSearchDialog, closeModuleSearchDialog } = moduleSearchDialogSlice.actions;

export default moduleSearchDialogSlice.reducer;
